import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BYPASS_INTERCEPTOR } from '../interceptor/interceptor.interceptor';
import { CoreService } from '../core/core.service';

export const REFRESH_TOKEN_API_URL: string = 'user/get_refresh_token'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private coreService: CoreService,
  ) {};

  login(data: any): Observable<any> {
    const loginUrl: string = environment.LOGIN_URL;

    return this.http.post(loginUrl + '/user/social_login', data, {
      context: new HttpContext().set(BYPASS_INTERCEPTOR, true),
      headers: {
        'x-api-key': environment.name.includes('stage-star') ? 'pof2tllTW43omxUYadpspakHeuF6NxXV5UkE4MaO' : '',
      }
    });
  }

  getGoogleClientID(data: any = {}): Observable<any> {
    const loginUrl: string = environment.LOGIN_URL;
    return this.http.post(loginUrl + '/user/get_login_info', data, {
      context: new HttpContext().set(BYPASS_INTERCEPTOR, true)
    });
  }

  getRefreshToken(payload: any): Observable<any>{
    return this.coreService.callPostApi(REFRESH_TOKEN_API_URL, payload);
  }
}
